export default "__VITE_ASSET__B$XH6gQS__"